/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConfiguredGraph } from '../../models/configured-graph';

export interface GetsConfiguredGraphs$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * if true, retrieve only the configured graphs that must be shown in the dashboard, if false return all
 */
  inDashboard?: boolean;
}

export function getsConfiguredGraphs(http: HttpClient, rootUrl: string, params: GetsConfiguredGraphs$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ConfiguredGraph>>> {
  const rb = new RequestBuilder(rootUrl, getsConfiguredGraphs.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.query('inDashboard', params.inDashboard, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ConfiguredGraph>>;
    })
  );
}

getsConfiguredGraphs.PATH = '/stations/{uid}/graph/configured';
